import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import styles from './ChoosePaymentMethod.module.scss';
import { modalBack } from 'legacy/actions/modalActions';
import { UserCard } from 'legacy/common/types/models';

import Card from '../../util/Card/Card';
import ModalBase from '../ModalBase/ModalBase';

// Simplified using existing UserCard type
interface ChoosePaymentMethodProps {
  selectedCard?: UserCard;
  cards: UserCard[];
  onCardSelect: (card: UserCard) => void;
  baseModalProps?: any;
}

interface ChoosePaymentMethodState {
  selectedCard: UserCard;
}

class ChoosePaymentMethod extends Component<ChoosePaymentMethodProps, ChoosePaymentMethodState> {
  constructor(props: ChoosePaymentMethodProps) {
    super(props);
    let { selectedCard } = props;
    const { cards } = props;
    // if none is passed, look for a default card (this should never be needed, but safer to have)
    if (!selectedCard) {
      selectedCard = cards.find((card) => card.default) || cards[0];
    }

    this.state = {
      selectedCard
    };
  }

  render() {
    const cards = this.props.cards.map((card) => (
      <div
        key={card._id}
        onClick={() => this.setState({ selectedCard: card })}
        className={classnames('card', {
          active: this.state.selectedCard._id === card._id
        })}
      >
        <Card card={card} width="80%" enableHover={false} handleDelete={() => {}} {...({} as any)} />
      </div>
    ));

    const { onCardSelect } = this.props;

    const onDone = () => {
      onCardSelect(this.state.selectedCard);
    };

    return (
      <ModalBase
        baseModalProps={this.props.baseModalProps}
        back_img="Back"
        contentClassName="basic"
        // if user clicks back, still persist selected card
        onBack={onDone}
      >
        <div className={classnames(styles.ChoosePaymentMethod, 'component')}>
          <div className="cards">{cards}</div>

          <div className="bn-btn plain" onClick={onDone}>
            SELECT CARD
          </div>
        </div>
      </ModalBase>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    cards: state.payment.cards
  };
}

const actions = { modalBack };

export default connect(mapStateToProps, actions)(ChoosePaymentMethod as any);
